import {Question} from './question.model';

export class MultiQuestions {
  russian: Question[];
  english: Question[];

  constructor(russian: Question[], english: Question[]) {
    this.russian = russian;
    this.english = english;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/multi-questions.ts